import React, { useState, useEffect } from 'react';
import { Stack, Button, Badge, Form } from 'react-bootstrap';
import FilterDropdown from './FilterDropdown';
import FilterModal from './FilterModal';
import { clearFilters, countActiveFilters } from './filterUtils';
import { FaFilter } from 'react-icons/fa';
import FilterDateRangeDropdown from '../../pages/transactions/FilterDateRangeDropdown';

const Filters = ({ config, value = {}, onChange, className }) => {
  const [selected, setSelected] = useState(value);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    setSelected(value);
  }, [value]);

  const handleDropdownApply = (sectionKey, values) => {
    const newSelected = { ...selected, [sectionKey]: values };
    setSelected(newSelected);
    onChange(newSelected);
  };

  const handleModalToggle = (sectionKey, val) => {
    setSelected((prev) => {
      const current = Array.isArray(prev[sectionKey]) ? prev[sectionKey] : [];
      const next = current.includes(val)
        ? current.filter((v) => v !== val)
        : [...current, val];
      return { ...prev, [sectionKey]: next };
    });
  };

  const handleModalDateChange = (sectionKey, field, value) => {
    setSelected((prev) => {
      const current = prev[sectionKey] || {};
      const updated = { ...current, [field]: value };
      return { ...prev, [sectionKey]: updated };
    });
  };


  const applyModal = () => {
    onChange(selected);
    setModalOpen(false);
  };

  const clearAll = () => {
    const cleared = clearFilters(config);
    setSelected(cleared);
    onChange(cleared);
  };

  const dropdowns = config.filter((c) => c.type === 'dropdown');
  const dateRanges = config.filter((c) => c.type === 'date-range');
  const modals = config;
  const totalActive = countActiveFilters(selected);

  return (
    <>
      <Stack className={className}  direction="horizontal" gap={2}>
        {dropdowns.map((section) => (
          <FilterDropdown
            key={section.key}
            section={section}
            selectedValues={selected[section.key] || []}
            onApply={handleDropdownApply}
          />
        ))}
        {dateRanges.map((section) => (
          <FilterDateRangeDropdown
            key={section.key}
            section={section}
            selected={selected[section.key]}
            onChange={handleDropdownApply}
          />
        ))}


        {modals.length > 0 && (
          <Button variant="outline-primary" size={"sm"} onClick={() => setModalOpen(true)}>
            <FaFilter/> Filtry{' '}
            {totalActive > 0 && (
              <>
                {'('}
                {totalActive}
                {')'}
              </>
            )}
          </Button>
        )}
      </Stack>

      <FilterModal
        show={modalOpen}
        onClose={() => setModalOpen(false)}
        config={modals}
        selected={selected}
        onToggle={handleModalToggle}
        onDateChange={handleModalDateChange}
        onApply={applyModal}
        onClear={clearAll}
      />

    </>
  );
};

export default Filters;
